import { Link, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { useI18n } from "@/i18n/I18nProvider";
import { ArrowUpRight } from "lucide-react";

const NotFound = () => {
  const location = useLocation();
  const { t } = useI18n();

  useEffect(() => {
    console.error("404:", location.pathname);
  }, [location.pathname]);

  return (
    <section className="mx-auto max-w-7xl px-6 lg:px-10 py-32 lg:py-48 text-center">
      <p className="font-mono text-xs uppercase tracking-wider text-muted-foreground mb-6">— 404</p>
      <h1 className="font-display text-6xl lg:text-9xl font-semibold tracking-tighter mb-8">
        {t.notFound.title}
      </h1>
      <p className="text-lg text-muted-foreground max-w-md mx-auto mb-10">{t.notFound.body}</p>
      <Link to="/" className="inline-flex h-12 items-center gap-2 rounded-full bg-foreground px-6 text-sm font-medium text-background hover:opacity-90 transition">
        {t.notFound.back}
        <ArrowUpRight className="h-4 w-4" />
      </Link>
    </section>
  );
};

export default NotFound;
